import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import { isPartnerAdminPreview, isPartnerAdminPreviewWithoutRole, isPartnerMasterSelfTest } from "../../lib/partnerNav";
import { tt } from "../../i18n/tt";

/**
 * 「어드민 확인용」 띠 (2026-09-11, 기획 docs/ops/partner-center-access-plan.md §4·§6 · 대표 결정 ④)
 *   Admin 겸직(Partner 역할도 있는 어드민)이 /partner* 를 열면 파트너 레이아웃 그대로 보되, 이 띠로 「내가 지금 파트너 화면을 보고 있다」를
 *   알리고 크리에이터 화면으로 돌아가는 길을 준다. 파트너 단독 계정·크리에이터에게는 아무것도 그리지 않는다.
 *   서명·수료 단추 잠금은 PartnerHub 가 같은 판정(isPartnerAdminPreview)으로 한다 — 띠만 있고 단추가 열려 있으면 대리 서명이 된다.
 */
export default function PartnerAdminPreviewBand() {
  const { userInfo } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  if (!isPartnerAdminPreview(userInfo?.role, location.pathname)) return null;
  const withoutRole = isPartnerAdminPreviewWithoutRole(userInfo?.role, location.pathname);
  const selfTest = isPartnerMasterSelfTest(userInfo?.role, location.pathname);
  return (
    <Box role="status" bg="statusWash.warning" borderBottom="1px solid" borderColor="statusLine.warning" px={{ base: 4, md: 5 }} py={1.5}>
      <Flex align="center" gap={3} maxW="1400px" mx="auto" fontSize="xs" color="neutral.800" flexWrap="wrap">
        <Text as="span" fontWeight="700" color="status.warning">{selfTest ? tt("a.40ce14a8", "운영팀 마스터 테스트") : tt("a.1edb7eda", "운영팀 확인용")}</Text>
        <Text as="span">
          {selfTest
            ? tt("a.58b4d4dd", "이 계정은 파트너 기능을 끝까지 해 볼 수 있습니다. 서명·수료·채널 등록은 이 계정 본인 이름으로 실제 기록됩니다.")
            : withoutRole
            ? tt("a.8bc1a516", "이 계정엔 Partner 역할이 없어 원장 없이 새 파트너가 보는 둘러보기 화면을 미리 봅니다. 실제 파트너로 확인하려면 회원 관리에서 Partner 역할을 함께 주세요.")
            : tt("a.b795efff", "파트너에게 보이는 화면 그대로입니다. 서명·수료 단추는 잠겨 있어요.")}
        </Text>
        <Box as="button" type="button" ml="auto" fontWeight="600" color="brand.700" textDecoration="underline" onClick={() => navigate("/home")}>
          {tt("a.8ec992fe", "크리에이터 화면으로")} →
        </Box>
      </Flex>
    </Box>
  );
}
